<template>
    <div>
        <b-button variant="primary" @click.stop="abrirModal()"
            >Inserir Itens</b-button
        >
        <b-modal
            v-model="mostrarModal"
            @show="preencherModal()"
            @hidden="fecharModal()"
            size="xl"
            no-close-on-backdrop
        >
            <div slot="modal-title">Inserir Itens de Contrato</div>
            <b-alert show>
                <span>
                    Fase:
                    <strong>{{ faseDemandaAtual.descricao }}</strong>
                    <br />Saldo:
                    <strong>{{ faseDemandaAtual.saldo | currency }}</strong>
                </span>
            </b-alert>
            <h5 class="heading-1 mb-4">
                <span>DISPONÍVEIS</span>
            </h5>
            <b-row>
                <b-col sm="12">
                    <app-tabela
                        :itens="itensNaoSelecionados"
                        :campos="campos"
                        :itensPorPagina="itensPorPagina"
                        :bordered="false"
                        :small="true"
                    >
                        <template slot="acoes" slot-scope="data">
                            <btn-selecionar-item-requisicao
                                :itemContrato="data"
                                :saldoMaximo="faseDemandaAtual.saldo"
                                @selecionarItem="selecionarItem($event)"
                                v-if="faseDemandaAtual.saldo"
                            ></btn-selecionar-item-requisicao>
                        </template>
                        <template slot="valorUnitario" slot-scope="data">{{
                            data.valorUnitario | currency
                        }}</template>
                        <template slot="saldoValor" slot-scope="data">{{
                            data.saldoValor | currency
                        }}</template>
                        <template slot="saldoQtd" slot-scope="data">
                            <span v-if="data.controlaSaldoQtd">{{
                                data.saldoQtd
                            }}</span>
                            <span v-if="!data.controlaSaldoQtd"
                                >N/A</span
                            ></template
                        >
                    </app-tabela>
                </b-col>
            </b-row>
            <h5 class="heading-1 mb-4">
                <span>SELECIONADOS</span>
            </h5>
            <b-row>
                <b-col sm="12">
                    <app-tabela
                        :itens="itensSelecionados"
                        :campos="campos2"
                        :itensPorPagina="itensPorPagina"
                        :bordered="false"
                        :small="true"
                    >
                        <template slot="acoes" slot-scope="data">
                            <btn-remover-item-selecionado
                                :itemContrato="data"
                                @removerItem="removerItem($event)"
                            ></btn-remover-item-selecionado>
                        </template>
                        <template slot="valorUnitario" slot-scope="data">{{
                            data.valorUnitario | currency
                        }}</template>
                        <template slot="quantidade" slot-scope="data">{{
                            data.quantidade | currency2
                        }}</template>
                        <template slot="valorTotal" slot-scope="data">{{
                            data.valorTotal | currency
                        }}</template>
                    </app-tabela>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModal()"
                    class="mr-2"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="itensSelecionados.length == 0"
                    @click.stop="confirmarSalvar()"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import RequisicoesServicos from './RequisicoesServicos'
import BtnSelecionarItemRequisicao from './BtnSelecionarItemRequisicao'
import BtnRemoverItemSelecionado from './BtnRemoverItemSelecionado'

export default {
    props: {
        requisicao: {
            type: Object
        }
    },

    components: {
        BtnSelecionarItemRequisicao,
        BtnRemoverItemSelecionado
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
            itensDisponiveis: [],
            itensSelecionados: [],
            campos: [
                {
                    key: 'acoes',
                    label: ''
                },
                {
                    key: 'itemContratoId',
                    label: 'Código',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descricao',
                    label: 'Item do Contrato',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'valorUnitario',
                    label: 'Valor Unitário',
                    sortable: true,
                    tdClass: 'text-right'
                },
                {
                    key: 'seqRM',
                    label: 'Seq RM',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'saldoValor',
                    label: 'Saldo Valor',
                    sortable: true,
                    tdClass: 'text-right'
                },
                {
                    key: 'saldoQtd',
                    label: 'Saldo Qtd',
                    sortable: true,
                    tdClass: 'text-center'
                }
            ],
            campos2: [
                {
                    key: 'acoes',
                    label: ''
                },
                {
                    key: 'itemContratoId',
                    label: 'Código',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descricao',
                    label: 'Item do Contrato',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'valorUnitario',
                    label: 'Valor Unitário',
                    sortable: true,
                    tdClass: 'text-right'
                },
                {
                    key: 'quantidade',
                    label: 'Qtd',
                    sortable: true,
                    tdClass: 'text-right'
                },
                {
                    key: 'valorTotal',
                    label: 'Valor Total',
                    sortable: true,
                    tdClass: 'text-right'
                }
            ],
            itensPorPagina: 5,
            faseDemandaAtual: {},
            saldoFase: 0
        }
    },

    methods: {
        fecharModal() {
            this.itensDisponiveis = []
            this.itensSelecionados = []
            this.mostrarModal = false
        },

        abrirModal() {
            this.mostrarModal = true
        },

        preencherModal() {
            this.obterItensDisponiveis()
            this.obterFaseDemandaAtual()
        },

        obterItensDisponiveis() {
            this.$store.dispatch('addRequest')
            RequisicoesServicos.obterItensDisponiveis(
                this.requisicao.idRequisicao
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.itensDisponiveis = [...response.data]
                    } else {
                        this.$toast.error(
                            'Erro ao obter itens do contrato',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
        
        obterFaseDemandaAtual() {
            this.$store.dispatch('addRequest')
            RequisicoesServicos.obterFaseDemandaAtual(
                this.requisicao.idContrato
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.faseDemandaAtual = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter fase do contrato',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }, 

        selecionarItem(itemSelecionado) {
            this.itensSelecionados.push(itemSelecionado)
        },

        removerItem(itemRemovido) {
            for (
                let index = 0;
                index < this.itensSelecionados.length;
                index++
            ) {
                const itemAtual = this.itensSelecionados[index]
                if (itemAtual.itemContratoId == itemRemovido.itemContratoId) {
                    this.itensSelecionados.splice(index, 1)
                    break
                }
            }
        },

        confirmarSalvar() {
            this.$swal({
                title: 'Inserção de itens na requisição',
                html: `Confirma a inserção dos itens na requisição?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            this.$emit('inserirItens', this.itensSelecionados)
            this.fecharModal()
        }
    },

    computed: {
        itensNaoSelecionados() {
            return this.itensDisponiveis.filter((itemDisponivel) => {
                return this.itensSelecionados.every((itemSelecionado) => {
                    return (
                        itemSelecionado.itemContratoId !==
                        itemDisponivel.itemContratoId
                    )
                })
            })
        }
    },

    created() {}
}
</script>
